import { Text } from '#app/components/Primitives/Text.js';
import { ProBadge } from '#app/components/ProBadge/ProBadge.js';
import { TextStyles } from '#app/theme/textStyles.js';
import { useModalContext } from '../hooks/useModalContext.js';
import { BetaTag, IconContainer, Title } from './Modal.styles.js';
import { type HTMLAttributes, type ReactNode } from 'react';

type ModalTitleProps = HTMLAttributes<HTMLDivElement> & {
  readonly betaTag?: boolean;
  readonly headerTextStyle?: NonNullable<TextStyles>;
  readonly icon?: ReactNode;
  readonly justifyContent?: 'center' | 'flex-start';
  readonly proTag?: boolean;
};

const ModalTitle = ({
  betaTag,
  children,
  headerTextStyle = 'sixthLevelHeadline',
  icon,
  justifyContent,
  proTag,
}: ModalTitleProps) => {
  const { titleProps } = useModalContext();

  return (
    <Title
      justifyContent={justifyContent}
      {...titleProps}
    >
      {icon ? <IconContainer>{icon}</IconContainer> : null}
      <Text textStyle={headerTextStyle}>{children}</Text>
      {betaTag ? <BetaTag>Beta</BetaTag> : null}
      {proTag ? <ProBadge /> : null}
    </Title>
  );
};

ModalTitle.displayName = 'Modal.Title';

export { ModalTitle };
